import { Answer } from './answer.model';

export class AnswerMapper {
  public static map(answerData: any): Answer {
    if (!answerData) {
      return null;
    }

    return new Answer (
        answerData.id,
        answerData.content,
        answerData.correct,
        answerData.order,
        answerData.value
      );
    }
}



// WEBPACK FOOTER //
// /dist/src/app/question/answer.mapper.ts